<ng-container *ngIf="(homeGraphData$ | async) as homeData">
  <section class="content head home-header">
    <div class="content-wrapper">
      <iaud-home-title [loginName]="homeData.loginName" [taskCount]="homeData.taskCount"></iaud-home-title>
    </div>
  </section>
  <section class="content">
    <div class="content-wrapper home-contents">
      <mat-accordion [multi]="true">
          <iaud-sid-graph [data]="homeData" [refreshCallback]="reloadEvent"></iaud-sid-graph>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              My Tasks
            </mat-panel-title>
          </mat-expansion-panel-header>
          <iaud-my-tasks></iaud-my-tasks>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </section>
</ng-container>